<template>
  <div class="listing-content" :style="{ color: `${info.PU ? '#f8f8f8' : '#020202'}`}">
    <div class="listing-print-image">
      <img :src="info.PU ? info.PU : blitzlogo">
    </div>
    <div>
      <h4>{{ info.AD ? info.AD.replace(' ,', ',') : 'Gainesville, FL'}}</h4>
      <h6>Host: {{ info.HA + ', ' + (info.HP ? info.HP.replace(')', ') ') : '(352) 371-6100') }}</h6>
      <h6>{{ 'Sunday ' + info.BT.replace(/PM/g, 'pm').replace('-', ' - ').replace(',', ', ') }}</h6>
      <p><span class="price">{{ info.MP ? '$'+ info.MP : '' }}</span>{{ '  ' + info.BR + '&nbsp;bedrooms,  ' + info.BA + '&nbsp;bathrooms&nbsp;&nbsp;  ' + info.SF + ' sq.ft.'}}</p>
      <ul>
        <li>{{ info.F1}}</li>
        <li>{{ info.F2}}</li>
        <li>{{ info.F3}}</li>
        <li>{{ info.F4}}</li>
      </ul>
    </div>      
  </div>
</template>

<script>
export default {
  name: 'PrintList',
  props: ['info'],
  data: function () {
    return {
      blitzlogo: require('@/assets/blitzlogo.jpg')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  img {
    width: 100%;
    border: 1px solid black;
  }
  ul {
    list-style-type: none;
  }
  .price {
    font-size: 1.4em;
  }
  .listing-print-image {
    width: 350px;
    margin-right: 15px;
  }
  .listing-content {
    display: flex;
    margin: 2em;
    color: black!important;
    page-break-inside: avoid;
  }
</style>



// WEBPACK FOOTER //
// src/components/PrintList.vue